import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://famconnect26.com/backend/',
    timeout: 30000, // Set timeout to 30 seconds
});

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
    function (config) {
        const token = JSON.parse(localStorage.getItem('token'));
        if (token) {
        // config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImRiYmI1MzE1LTk4ZjAtNDc5Yi04NTJhLWNiOWFiOGViMDA2YyIsImlhdCI6MTcyNjczMzMyOSwiZXhwIjoxNzI5MzI1MzI5fQ.qMuc1_7mrbz0AkbTNTxmNLLPFkD1UXrRfcqlS6NfiI4`;
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
},
function (error) {
    return Promise.reject(error);
}
);

const localVersion = localStorage.getItem('frontend_version');
axiosInstance.interceptors.response.use(
    function (response) {

        // console.log('response?.headers?.Frontend_version1',response.headers.get('frontend_version'));
        // console.log('response?.headers?.Frontend_version2',response.headers.get('frontend_version'));
        localStorage.setItem('frontend_version',response.headers.get('frontend_version'))
        if(localVersion === response?.headers?.frontend_version){
            return response;
        } else if(localVersion == null || localVersion == undefined || localVersion == 'undefined' || localVersion == 'null'){
            return response;
        } else{
            localStorage.clear();
            window.location.href = '/login';
            
        }
        // return response;
    },
    function (error) {
        if (error?.response?.status === 401) {
            // Unauthorized - clear storage and redirect to login
            localStorage.clear();
            window.location.href = '/login';
        }
        // else{
        //     toast.error(error?.response?.data?.message)
        // }
        return error?.response;
        // return Promise.reject(error);
    }
);
export default axiosInstance;
